module.exports = __webpack_public_path__ + "img/CM-MS-24-Mitsubishi-Established.3faf7a93.jpg";